//__made by Mateusz Janeczek__

import React from 'react';
import { Dropdown, DropdownButton, MenuItem, FormControl, Col, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/lib/Modal';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Button from 'react-bootstrap/lib/Button';
import Popover from 'react-bootstrap/lib/Popover';
import Tooltip from 'react-bootstrap/lib/Tooltip';
import { connect } from 'react-redux';
import s from './RegisterModal.scss';
import InputWithValidator from '../../InputWithValidator/InputWithValidator';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

class RegisterModal extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      isChecked: false,
      imie: '',
      nazwisko: '',
      email: '',
      haslo1: '',
      haslo2: '',
      powiat: '',
      powiatIndex: '',
      gmina: '',
      gminaIndex: '',
      prefix: null,
      miejscowosc: '',
      menuIsOpen: false,
      imieValid: false,
      nazwiskoValid: false,
      emailValid: false,
      hasloValid: false,
      haslo1Valid: false,
      haslo2Valid: false,
      powiatValid: true,
      gminaValid: true,
      miejscowoscValid: false,
      allDataValid: true,
    };
    this.onCheck = this.onCheck.bind(this);
  }

  onChanger = (e) => {
    this.setState({ inputValue: e.target.value })
  };

  onCheck = () => {
    this.setState({
      isChecked: !this.state.isChecked,
    });
  }

  choosePowiat = (e) => {
    this.setState({
      powiat: e.label,
      powiatValid: true,
      powiatIndex: e.value,
    });
    this.props.pobierzListGmin(e.label);
  };

  chooseGmina = (e) => {
    this.setState({
      prefix: e.prefix,
      gmina: e.label,
      gminaValid: true,
      gminaIndex: e.value,
    });
  }

// walidacje danych =================================================================================
  validateImie = (val, shouldValid) => {
    const letterRegex = /^[A-Za-zżźćńółęąśŻŹĆĄŚĘŁÓŃ]*$/;
    if ((val != '' && val.length > 2) && letterRegex.test(val)){
      this.setState({imie: val, imieValid: true});
      return true;
    } else {
      console.error("niepoprawne imię!");
      this.setState({imieValid: false});
      return false;
    }    
  }

  validateNazwisko = (val, shouldValid) => {
    const letterRegex = /^[A-Za-zżźćńółęąśŻŹĆĄŚĘŁÓŃ]*$/;
    if ((val != '' && val.length >= 2 ) && letterRegex.test(val)){
      this.setState({nazwisko: val, nazwiskoValid: true});
      return true;
    } else {
      console.error("niepoprawne nazwisko!");
      this.setState({nazwiskoValid: false});
      return false;
    }    
  }

  validateEmail = (val, shouldValid) => {
    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (val != '' && emailRegex.test(val) ){
      this.setState({email: val, emailValid: true});
      return true;
    } else {
      this.setState({emailValid: false});
      console.error("niepoprawne nazwisko!");
      return false;
    }    
  }

  validateHaslo1 = (val, shouldValid) => {
    const hasloRegex = /^[^-\s]*$/;
    if (val != '' && hasloRegex.test(val) && val.length >= 8){
      this.setState({haslo1: val, haslo1Valid: true});
      return true;
    } else {
      this.setState({haslo1Valid: false});
      console.error("niepoprawne haslo1!");
      return false;
    }    
  }

  validateHaslo2 = (val, shouldValid) => {
    if (val === this.state.haslo1){
      this.setState({haslo2: val, haslo2Valid: true});
      return true;
    } else {
      this.setState({haslo2Valid: false});
      console.error("niepoprawne haslo2!");
      return false;
    }    
  }

  validateMiejscowosc = (val, shouldValid) => {
    const miejscowoscRegex = /^[A-Za-zżźćńółęąśŻŹĆĄŚĘŁÓŃ\s]*$/;
    if (val != '' && val.length >= 2 && miejscowoscRegex.test(val) ){
      this.setState({miejscowosc: val, miejscowoscValid: true});
      return true;
    } else {
      this.setState({miejscowoscValid: false});
      console.error("niepoprawna miejscowość!");
      return false;
    }    
  }

  registerUser = (e) =>{
    //funckja wysylajaca request gdy dane sie zgadzaja
    let {imie, nazwisko, email, haslo1, haslo2, 
        powiat, prefix, gmina, miejscowosc, imieValid, 
        nazwiskoValid, emailValid, haslo1Valid, haslo2Valid, 
        prefixValid, miejscowoscValid} = this.state;
    if (powiat != ''){
      this.setState({powiatValid: true});     
    } else {
      this.setState({powiatValid: false});
      console.error("wybierz powiat!"); 
    }
    if (gmina != ''){
      this.setState({gminaValid: true});
    } else {
      this.setState({gminaValid: false});
      console.error("wybierz gminę!");
    } 
    if (imieValid && nazwiskoValid && emailValid && haslo1Valid && haslo2Valid && this.state.powiatValid && this.state.gminaValid && miejscowoscValid) {
      //przesyła request do serwera o stworzenie konta o podanych danych
      this.props.createUser(imie, nazwisko, email, haslo1, prefix, miejscowosc);
      this.setState({allDataValid: true})
    } else {
      e.preventDefault();
      this.setState({allDataValid: false})
    }
  } 

  render() {
    const popover = (
      <Popover id="modal-popover" title="popover">
        very popover. such engagement
      </Popover>
    );
    const tooltip = (
      <Tooltip id="modal-tooltip">
        wow.
      </Tooltip>
    );
    let powiatTitle = this.state.powiat !='' ? this.state.powiat : "Wybierz powiat";
    let gminaTitle = this.state.gmina !='' ? this.state.gmina : "Wybierz gminę";

    const wybierzPowiat = [{value: 0, label: "Wybierz powiat by pobrać listę gmin"}]
    let listaPowiatow = [];
    let listaGmin = [];
    this.props.arePowiatyFetched ? this.props.powiaty.powiaty.powiaty.sort().map((v, i) => { listaPowiatow.push({ value: i, label: v }); }) : null;
    (this.props.areGminyFetched && this.props.arePowiatyFetched && this.state.powiat != '') ? this.props.gminy.gminy.map((v, i) => { listaGmin.push({ value: i, label: v.nazwa, prefix: v.prefix }); }) : null;

    return (
      <Modal show={this.props.showModal} onHide={this.props.close}>
        <Modal.Body>
          <div className="row">
            <div className="col-xs-2" />
            <div className="col-xs-8">
              <div className={"form-wrap"}>
                <h1>{this.props.intl.utwKonto}</h1>
                {this.props.intl.wypPoniPolaNoweHaslo}:<br/><br/>
                <form role="form">
                  <InputWithValidator placeHolder={this.props.intl.wprowadzImie} inputName={this.props.intl.imie} type="text" allDataValid={this.state.allDataValid} validateMe={this.validateImie} errorMessage="Nieprawidłowe imie!" />
                  <InputWithValidator placeHolder={this.props.intl.nazwisko} inputName={this.props.intl.nazwisko} type="text" allDataValid={this.state.allDataValid} name="nazwisko_input" validateMe={this.validateNazwisko} errorMessage="Nieprawidłowe nazwisko!" />
                  <InputWithValidator placeHolder={this.props.intl.wprowadzEmail} inputName="Email" type="email" allDataValid={this.state.allDataValid} name="email_input" validateMe={this.validateEmail} errorMessage="Nieprawidłowy adres email!" />
                  <InputWithValidator placeHolder={this.props.intl.wprHasloMusiZawMin8Zn} inputName={this.props.intl.haslo} type="password" allDataValid={this.state.allDataValid} validateMe={this.validateHaslo1} errorMessage="Niepoprawne hasło. Musi zawierać minimum 8 znaków BEZ spacji!" />
                  <InputWithValidator placeHolder={this.props.intl.powtWprowadzoneHaslo} inputName={this.props.intl.powtHaslo} type="password" allDataValid={this.state.allDataValid} validateMe={this.validateHaslo2} errorMessage="Niepoprawne powtórzenie hasła!" />

                  <div className={"form-group"}>
                    <label htmlFor="asda">Powiat i Gmina</label>
                    <Row className="show-grid">
                      <Col sm={6}>
                        <Select
                          name="form-field-name"
                          placeholder={this.props.intl.wybierzPowiat}
                          value={this.state.powiatIndex}
                          options={listaPowiatow}
                          onChange={(e) => this.choosePowiat(e)}
                          clearable={false}
                        />             
                        {!this.state.powiatValid ? <span className="glyphicon glyphicon-warning-sign form-control-feedback"></span> : null}  
                        {!this.state.powiatValid ? <label style={{ color: "orange" }}>Wybierz powiat!</label> : null} 
                      </Col>

                      <Col sm={6}>
                        <Select
                          name="form-field-name"
                          placeholder={this.props.intl.wybierzGmine}
                          value={this.state.gminaIndex}
                          options={this.state.powiat !='' ? listaGmin : wybierzPowiat}
                          onChange={this.state.powiat !='' ? (e) => this.chooseGmina(e) : null}
                          clearable={false}
                        />
                        {!this.state.gminaValid ? <span className="glyphicon glyphicon-warning-sign form-control-feedback"></span> : null}  
                        {!this.state.gminaValid ? <label style={{color: "orange"}}>Wybierz gminę!</label> : null} 
                      </Col>
                    </Row>
                  </div>

                  <InputWithValidator placeHolder={this.props.intl.wprNazwMiejsc} inputName={this.props.intl.miejscowosc} type="text" name="miejscowość_input" validateMe={this.validateMiejscowosc} errorMessage="Niepoprawna nazwa miejscowości!" />

                  {this.props.hasError ? <p className="error"> {this.props.hasError} </p> : null}
                  <input type="submit" onClick={this.registerUser} id="btn-login" className={"btn btn-custom btn-lg btn-block"} value={this.props.intl.zarejestruj} />
                  <div className={this.state.allDataValid ? "form-group" : "form-group has-warning has-feedback"}>
                    {!this.state.allDataValid ? <label style={{color: "orange", textAlign: "center"}}>Proszę prawidłowo wypełnić wszystkie pola!</label> : null}                  
                  </div>                
                </form>
              </div>
            </div>
            <div className="col-xs-2" />
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapState = (state) => ({
  intl: state.intl.langKeys,
});

const mapDispatch = {
};

export default withStyles(s)(connect(mapState, mapDispatch)(RegisterModal));



// WEBPACK FOOTER //
// src/components/Modals/RegisterModal/RegisterModal.js